import { getMetaSuccess } from "@App/appReducer";
import { AppThunk } from "@Store/index";
import getPaymentSummary from "@Utils/getPaymentSummary";
import {
  fetchBookFormPageDataIfNeeded,
  updatePaymentInfo,
  updatePriceSummary,
  updateTokenPaymentData,
} from "./bookFormReducer";
import { fetchPayment } from "./loadPaymentSuccessData";

export const loadCustomPaymentData = (props: any) => async (dispatch: any, getState: any) => {
  let token = "";
  if (__CLIENT__) token = props?.match?.params?.token || "";
  else token = props.req.query.token || props.params.token;

  const userCurrency = getState()?.appData?.user_currency;
  const paymentData = await fetchPayment(token, userCurrency);

  dispatch(
    updateTokenPaymentData({
      data: paymentData,
      token,
      err: JSON.stringify(paymentData?.err),
    }),
  );

  if (paymentData?.fetch_payment_info) {
    dispatch(updatePaymentInfo({ payment_info: paymentData?.fetch_payment_info }));
    dispatch(
      updatePriceSummary({
        ...getPaymentSummary(paymentData?.fetch_payment_info),
        payment_info: paymentData?.fetch_payment_info,
      }),
    );
  }

  const meta: any = {};
  if (paymentData) {
    meta.title_prefix = "Payments";
    meta.description = "Book your long-term accommodation near universities across the globe.";
    meta.index = false;
  }

  dispatch(getMetaSuccess(meta));

  return dispatch(
    fetchBookFormPageDataIfNeeded(
      props,
      paymentData?.inventory_root?.canonical_name || paymentData?.inventory_root_id,
      true,
    ),
  );
};

const loadData = (props: any): AppThunk[] => [loadCustomPaymentData(props)];

export default loadData;
